import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../ui/button'
import { ArrowRight } from 'lucide-react'
import CircleButton from '../../leevo_ui/CircleButton/CircleButton'
import ProgressBar from '../../leevo_ui/ProgressBar/ProgressBar'
import arrow from '../../../images/arrow-thin.svg'

function headerBackgroundColorClass(color) {
  switch (color) {
    case 'purple':
      return 'bg-gradient-purple-700-500 text-white'
    default:
      return 'bg-white text-gray-900'
  }
}

function RegistrationLayout({
  title,
  stepper,
  progressPercentage,
  children,
  onClickNext,
  isNextDisabled,
  headerColor,
  className,
  showNextButton
}) {
  const showProgress = progressPercentage !== undefined && headerColor !== 'purple'

  return (
    <div className="min-h-screen bg-gray-50" data-cy="registration-layout">
      <div className="mx-auto max-w-7xl">
        <header className={`sticky top-0 z-10 ${headerBackgroundColorClass(headerColor)} shadow-sm`}>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="py-6">
              <h1 className="text-2xl font-bold mb-4">{title}</h1>
              {stepper && <div className="mt-4">{stepper}</div>}
            </div>
            {showProgress && <ProgressBar percentage={progressPercentage} />}
          </div>
        </header>

        <main className="pb-24">
          <div className={`mx-auto ${className}`}>{children}</div>
        </main>

        {onClickNext && showNextButton && (
          <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-10">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4">
              <div className="flex justify-end">
                <Button
                  onClick={onClickNext}
                  disabled={isNextDisabled}
                  className="bg-purple-600 hover:bg-purple-700"
                  size="lg"
                  data-cy="submit"
                >
                  Continue
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </div>
            </div>
          </div>
        )}

        {onClickNext && !showNextButton && (
          <CircleButton
            disabled={isNextDisabled}
            className="fixed bottom-6 right-6 bg-purple-700 border-none shadow-hover z-10"
            size={16}
            color="purple"
            svgSrc={arrow}
            onClick={onClickNext}
            data-cy="submit"
          />
        )}
      </div>
    </div>
  )
}

RegistrationLayout.headerColors = ['purple', 'white']

RegistrationLayout.defaultProps = {
  isNextDisabled: false,
  headerColor: 'white',
  className: '',
  showNextButton: false
}

RegistrationLayout.propTypes = {
  title: PropTypes.string.isRequired,
  stepper: PropTypes.node,
  className: PropTypes.string,
  progressPercentage: PropTypes.number,
  children: PropTypes.node.isRequired,
  onClickNext: PropTypes.func,
  isNextDisabled: PropTypes.bool,
  headerColor: PropTypes.oneOf(RegistrationLayout.headerColors).isRequired,
  showNextButton: PropTypes.bool
}

export default RegistrationLayout
